let $math = require("mathjs"); // 引入依赖

/**
 * 数据判空 - null、""、不存在这个字段
 * @param val
 * @returns {string|*}
 */
export function noData(val) {
  if (val !== null && val !== "" && val !== undefined) {
    return val;
  }
  return "--";
}

/**
 * 处理js计算不精准问题
 * @param _func
 * @param chain
 * @param args
 * @returns {*}
 */
function operation(_func, chain, args) {
  for (let i = 0, len = args.length; i < len; i++) {
    chain = chain[_func]($math.bignumber(args[i]));
  }
  return chain;
}
// 构建对象
function BigNumber(number) {
  this.chain = $math.chain($math.bignumber(number));
}
// 加减乘除中间操作
BigNumber.prototype.add = function (...rest) {
  this.chain = operation("add", this.chain, rest);
  return this;
};
// 输出函数
BigNumber.prototype.done = function () {
  return parseFloat(this.chain.done());
};
export const mathJs = (number) => new BigNumber(number);

/**
 * 判断是否在可视范围内
 * @param viewId 可滑动容器id
 * @param footerEl 按钮dom
 * @returns {boolean}
 */
export function isElementNotInViewport(viewId, footerEl) {
  let visualHeight =
    document.getElementsByClassName("routerView")[0].offsetHeight;
  let buyNavHeight = document.getElementById(
    "buyNavTab-container",
  ).offsetHeight;
  let viewHeight = document.getElementById(viewId).offsetHeight;
  let footerHeight = footerEl.offsetHeight;
  return buyNavHeight + viewHeight - footerHeight + 5 > visualHeight;
}

/**
 * 解决window.open不能打开新页面方法
 * @param url
 */
export function windowOpen(url) {
  const a = document.createElement("div");
  a.onclick = window.open(url, "_blank");
  a.remove();
}

/**
 * 保留小数位规则
 * 个位数大于1保留2位小数
 * 个位数小于1保留6为小数
 * @param {string | number | null | undefined} val
 * @returns { string | number } 转换后的数值
 */
export function numberHandle(val, decimalDigits) {
  if (val !== "" && val !== undefined && val != null) {
    if (
      decimalDigits !== "" &&
      decimalDigits !== undefined &&
      decimalDigits != null
    ) {
      let returnNumber;
      //截取小数点规则
      if (decimalDigits === 0) {
        returnNumber = Math.ceil(val);
      } else {
        //乘小数位
        let numLength = "1";
        //具体保留几位小数
        let sumLength = decimalDigits;
        for (let i = 0; i < sumLength; i++) {
          numLength += "0";
        }
        //保留完小数再除进1
        returnNumber = Math.ceil(val * numLength) / numLength;
      }

      isNaN(val) || returnNumber <= 0 ? (returnNumber = 0) : "";
      return returnNumber;
    }
    let returnNumber =
      val >= 1
        ? Math.floor(val * 100) / 100
        : Math.floor(val * 1000000) / 1000000;
    isNaN(val) || returnNumber <= 0 ? (returnNumber = 0) : "";
    return returnNumber;
  }
  return 0;
}

/**
 * Created by PanJiaChen on 16/11/18.
 */
export function timeDown(time) {
  if (time > 0) {
    var second = time;
    var minute = 0;
    var hour = 0;
    minute = parseInt((second / 60) % 60);
    hour = parseInt((second / 60 / 60) % 24);
    second %= 60;
    // if(minute>60) {
    //   minute%=60;
    // }
    second = second > 9 ? second : "0" + second;
    minute = minute > 9 ? minute : "0" + minute;
    hour = hour > 9 ? hour : "0" + hour;
    return `${hour !== "00" ? hour + ":" : ""}` + minute + ":" + second;
  }
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunda
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    }),
  ).join("&");
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach((v) => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + "";
  const randomNum = parseInt((1 + Math.random()) * 65536) + "";
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === "string" || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }
  return Array.isArray(arg);
}

/**
 * 快速改变页面数字，数字增加过程
 * @param {string} selector 可以被jquery选中的选择器（标签内不应有除了数字以外其他内容）
 * @param {Object} param1
 * {
 *    duration: 数字变化过程的时间 默认：2000sm,
 *    timeStep: 变化间隔时间 默认: 50ms,
 *    start: 数字变化起始值,
 *    end: 数字变化最终值
 * }
 */
export function ChangeDomNum(selector, _ref) {
  var start, end, duration, timeStep;
  start = _ref.start;
  end = _ref.end;
  duration = _ref.duration;
  timeStep = _ref.timeStep;

  if (
    (duration && !isNumeric(duration)) ||
    (timeStep && !isNumeric(timeStep)) ||
    !isNumeric(start) ||
    !isNumeric(end) ||
    start === end
  ) {
    return false;
  } else {
    duration = parseFloat(duration);
    timeStep = parseFloat(timeStep);
    start = parseFloat(start);
    end = parseFloat(end);
  }

  var timeStepRel = timeStep || 50;
  var startRel = start || 0;
  var duringRel = duration || 2000;
  var result = startRel;
  var decimalPonit = Math.max(getDecimalPoint(end), getDecimalPoint(start)); // 几位小数

  var timeCount = Math.ceil(duringRel / timeStepRel);
  var step = parseFloat(((end - startRel) / timeCount).toFixed(decimalPonit));
  var timer = null;
  timer = setInterval(function () {
    step === 0 ? (step = 20) : "";
    result += step;

    if (_ref.start < _ref.end) {
      //增
      if (step > 0 && result >= end) {
        result = end;
        clearInterval(timer);
        timer = null;
      } else if (step < 0 && result <= start) {
        result = start;
        clearInterval(timer);
        timer = null;
      }
    } else {
      //减
      if (step < 0 && result <= end) {
        result = end;
        clearInterval(timer);
        timer = null;
      } else if (step > 0 && result >= start) {
        result = start;
        clearInterval(timer);
        timer = null;
      }
    }

    document.getElementById(selector)
      ? (document.getElementById(selector).innerText =
          result.toFixed(decimalPonit))
      : "";
  }, timeStepRel);
}
/**
 *判断一个数有几位小数
 *@param {number} number
 */
function getDecimalPoint(number) {
  if (!isNumeric(number)) {
    return;
  }
  var num = parseFloat(number);
  var str = num.toString();
  var x = str.indexOf(".");
  if (x > -1) {
    return str.length - x - 1;
  } else {
    return 0;
  }
}
// 判断是否是数字
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * 校验对象长度
 * @param {Object}
 * @return {boolean} >0 - true、===0 - false
 */

export function ObjectLength(obj) {
  return !(Object.keys(obj).length === 0);
}
